export enum StorageTypesEnum {
  TOKEN = 'TOKEN'
}
